(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
  const initializeBrandDirectories = () => document.querySelectorAll('[data-brand-directory]').forEach((directory) => {
    if (directory.dataset.brandDirectoryInitialized === 'true') return;

    const primaryGrid = directory.querySelector('[data-brand-grid]');
    const continuationSections = Array.from(document.querySelectorAll('.brand-directory--continuation'));

    continuationSections.forEach((continuation) => {
      const continuationGrid = continuation.querySelector('[data-brand-grid]');
      if (!continuationGrid) return;

      Array.from(continuationGrid.children).forEach((card) => primaryGrid.appendChild(card));
      continuation.hidden = true;
    });

    const search = directory.querySelector('[data-brand-search]');
    const filters = Array.from(directory.querySelectorAll('[data-brand-filter]'));
    const cards = Array.from(primaryGrid.querySelectorAll('[data-brand-card]'));
    const count = directory.querySelector('[data-brand-result-count]');
    const empty = directory.querySelector('[data-brand-empty]');
    const reset = directory.querySelector('[data-brand-reset]');
    const total = directory.querySelector('[data-brand-total]');
    const topButton = directory.querySelector('[data-brand-back-to-top]');
    let category = 'all';

    directory.dataset.brandDirectoryInitialized = 'true';

    total.textContent = cards.length;

    const render = () => {
      const query = search.value.trim().toLowerCase();
      let visible = 0;

      cards.forEach((card) => {
        const matchesSearch = card.dataset.brandName.includes(query);
        const matchesCategory = category === 'all' || card.dataset.brandCategory === category;
        const show = matchesSearch && matchesCategory;
        card.hidden = !show;
        if (show) visible += 1;
      });

      count.textContent = count.dataset.countTemplate.replace('COUNT', visible);
      empty.hidden = visible !== 0;
    };

    const update = () => {
      if (document.startViewTransition) {
        document.startViewTransition(render);
      } else {
        render();
      }
    };

    search.addEventListener('input', update);

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        category = filter.dataset.brandFilter;
        filters.forEach((item) => {
          const active = item === filter;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        update();
      });
    });

    reset.addEventListener('click', () => {
      search.value = '';
      category = 'all';
      filters.forEach((item) => {
        const active = item.dataset.brandFilter === 'all';
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      render();
      search.focus();
    });

    const updateTopButton = () => {
      if (!topButton) return;
      const visible = window.scrollY > 600;
      topButton.classList.toggle('is-visible', visible);
      topButton.setAttribute('aria-hidden', visible ? 'false' : 'true');
      topButton.tabIndex = visible ? 0 : -1;
    };

    if (topButton) {
      topButton.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
      window.addEventListener('scroll', updateTopButton, { passive: true });
      updateTopButton();
    }

    render();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBrandDirectories, { once: true });
  } else {
    initializeBrandDirectories();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  document.querySelectorAll('[data-info-page]').forEach((page) => {
    const topButton = page.querySelector('[data-info-back-to-top]');
    if (!topButton) return;
    const updateTopButton = () => {
      const visible = window.scrollY > 600;
      topButton.classList.toggle('is-visible', visible);
      topButton.setAttribute('aria-hidden', visible ? 'false' : 'true');
      topButton.tabIndex = visible ? 0 : -1;
    };
    topButton.addEventListener('click', () => window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
    window.addEventListener('scroll', updateTopButton, { passive: true });
    updateTopButton();
  });

  } catch(e) { console.error(e); }
})();
})();
